export default __webpack_public_path__ + "static/imaging-d973bec8599844a9bee1f099390f58f2.mp3";